import checkout from "./form";

const {
    formField: {
        name,
        email,
        phone,
        address,
        company,
        avatar,
    },
} = checkout;


const initialValues = {
    [avatar.name]: "",
    [name.name]: "",
    [phone.name]: "",
    [email.name]: "",
    [address.name]: "",
    [company.name]: ""
};


export default initialValues;
